/**
 * Available purchase order statuses (used by search filters and list prep).
 */
export const PurchaseStatuses = {
    open: 'open',
    closed: 'closed',
    pending: 'pending',
};

/**
 * Display labels for purchase order document status (action card select).
 */
export const PurchaseOrderStatuses = {
    open: 'Open',
    pending: 'Pending',
    partial: 'Partial',
    closed: 'Closed',
    cancelled: 'Cancelled',
};

export const PurchaseOrderStatusList = Object.values(PurchaseOrderStatuses);

/**
 * Document-level purchase history statuses (read-only on history single).
 */
export const PurchaseHistoryStatuses = {
    open: 'Open',
    partial: 'Partial',
    received: 'Received',
    invoiced: 'Invoiced',
    closed: 'Closed',
    cancelled: 'Cancelled',
};

export const PurchaseHistoryStatusList = Object.values(PurchaseHistoryStatuses);

